<template>
  <div class="remote-agreements">
    <Checkbox
      name="agreements_all"
      :show-error="showError && !allCheckboxesChecked"
      :value="allCheckboxesChecked"
      @change="handleCheckAll"
    >
      <p class="checkbox-text checkbox-text--bold">Akceptuję wszystkie zgody i oświadczenia</p>
    </Checkbox>
    <Checkbox name="agreements_policies" :show-error="showError && !policiesState" v-model="policiesState">
      <p class="checkbox-text">
        Akceptuję <a href="/terms.pdf" target="_blank">Warunki korzystania z usług</a> {{ siteName }} i zapoznałem(-am)
        się z <a href="/privacy-policy.pdf" target="_blank">Polityką prywatności</a> {{ siteName }}.
      </p>
    </Checkbox>
    <CollapsibleCheckbox
      :value="remarketingState.all"
      :opened="openAll && !remarketingState.all"
      :show-error="showError && !remarketingState.all"
      @change="updateMailingCheckboxes('all', $event)"
      @openedToggle="handleCollapsibleOpenedToggle('remarketing', $event)"
    >
      <template #text
        >Chcę dostawać od {{ siteName }} najnowsze informacje o produktach i usługach dopasowane do moich
        potrzeb</template
      >
      <template #content>
        <p class="agreement-text">
          Zgadzam się na otrzymywanie informacji handlowych od Fininity OÜ i jej powiązanych marek za pośrednictwem:
        </p>
        <Checkbox
          name="agreements_remarketing_all"
          :show-error="showError && !remarketingState.all"
          v-model="remarketingState.all"
          @change="updateMailingCheckboxes('all')"
        >
          <p class="checkbox-text">Zaznacz wszystkie</p>
        </Checkbox>
        <Checkbox
          name="agreements_email"
          :show-error="showError && !remarketingState.email"
          v-model="remarketingState.email"
          @change="updateMailingCheckboxes('email')"
        >
          <p class="checkbox-text">E-mail na adres, który podałem(-am) w formularzu kontaktowym</p>
        </Checkbox>
        <Checkbox
          name="agreements_sms"
          :show-error="showError && !remarketingState.sms"
          v-model="remarketingState.sms"
          @change="updateMailingCheckboxes('sms')"
        >
          <p class="checkbox-text">Wiadomości SMS na numer telefonu, który podałem(-am) w formularzu kontaktowym</p>
        </Checkbox>
        <p class="agreement-text">
          Możesz wypisać się w dowolnym momencie, klikając w <a :href="unsubLink" target="_blank">link</a>.
        </p>
      </template>
    </CollapsibleCheckbox>

    <CollapsibleCheckbox
      :disabled="remoteAgreementsNotLoaded"
      :value="remoteState.all"
      :opened="openAll && !remoteState.all"
      :show-error="showError && !remoteState.all"
      @change="updateCheckboxes"
      @openedToggle="handleCollapsibleOpenedToggle('partners', $event)"
    >
      <template #text>Akceptuję wszystkie zgody i oświadczenia Partnerów</template>
      <template #content>
        <CollapsibleCheckbox
          v-for="(lenderNames, category) in remoteAgreements"
          @change="updateCheckboxes($event, { category })"
          :value="remoteState[category].checked"
          :key="category"
          :name="category"
          :opened="openAll && !remoteState[category].checked"
          :show-error="showError && !remoteState[category].checked"
        >
          <template #text>{{ category }}</template>
          <template #content>
            <p
              class="agreement-text"
              v-if="
                category ===
                  'Akceptuję politykę prywatności i regulamin świadczenia usług za pośrednictwem niniejszej strony internetowej'
              "
            >
              Oświadczam, że zapoznałem się z <a href="/terms.pdf" target="_blank">regulaminem</a> świadczenia usług za
              pośrednictwem niniejszej strony internetowej i akceptuję jego treść (wyrażenie zgody jest wymagane dla
              rozpoczęcia realizacji procesu usług za pośrednictwem niniejszej strony internetowej jak również
              otrzymania oferty kredytowej). Oświadczam, że zapoznałem/am się i akceptuję postanowienia
              <a href="/privacy-policy.pdf" target="_blank">Polityki prywatności</a>.
            </p>
            <CollapsibleCheckbox
              v-for="(agreements, lenderName) in lenderNames"
              @change="updateCheckboxes($event, { category, lenderName })"
              :value="remoteState[category].lenders[lenderName].checked"
              :key="lenderName"
              :name="lenderName"
              :opened="openAll && !remoteState[category].lenders[lenderName].checked"
              :show-error="showError && !remoteState[category].lenders[lenderName].checked"
            >
              <template #text>{{ lenderName }}</template>
              <template #content>
                <CollapsibleCheckbox
                  v-for="(agreement, index) in agreements"
                  @change="updateCheckboxes($event, { category, lenderName, agreementName: agreement.name })"
                  v-model="agreement.checked"
                  :value="agreement.checked"
                  :key="index"
                  :name="index"
                  :opened="openAll && !agreement.checked"
                  :show-error="showError && agreement.required && !agreement.checked"
                >
                  <template #text>
                    <p class="agreement-title" v-html="splitStringByWords(agreement.description).title"></p>
                  </template>
                  <template v-if="splitStringByWords(agreement.description).restText" #content>
                    <p class="agreement-text" v-html="splitStringByWords(agreement.description).restText"></p>
                  </template>
                </CollapsibleCheckbox>
              </template>
            </CollapsibleCheckbox>
          </template>
        </CollapsibleCheckbox>
      </template>
    </CollapsibleCheckbox>
  </div>
</template>

<script>
import CollapsibleCheckbox from './CollapsibleCheckbox.vue'
import Checkbox from './Checkbox.vue'

export default {
  name: 'RemoteAgreements',
  components: { Checkbox, CollapsibleCheckbox },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showError: {
      type: Boolean | undefined,
      required: true
    }
  },
  data() {
    return {
      remoteAgreements: {},
      openAll: false,
      policiesState: false,
      remarketingState: {
        all: false,
        email: false,
        sms: false
      },
      remoteState: {
        all: false,
        allRequired: false
      },
      maxChars: 100,
      agreementsUnlock: false
    }
  },
  computed: {
    remoteAgreementsNotLoaded() {
      return Object.keys(this.remoteAgreements).length === 0 && !this.agreementsUnlock
    },
    siteName() {
      const domainParts = window.location.hostname.replace(/^www\./, '').split('.')
      const sitename = domainParts[0] || window.location.hostname
      return sitename.charAt(0).toUpperCase() + sitename.slice(1)
    },
    unsubLink() {
      const hostname = window.location.hostname
      return `https://unsub.${hostname}/gdpr?country=PL`
    },
    allCheckboxesValid() {
      return this.policiesState && this.remarketingState.all && this.remoteState.allRequired
    },
    allCheckboxesChecked() {
      return this.policiesState && this.remarketingState.all && this.remoteState.all
    }
  },
  async mounted() {
    try {
      this.remoteAgreements =
        JSON.parse(sessionStorage.getItem('remoteAgreements')) || (await this.$store.dispatch('getAgreements'))
      sessionStorage.setItem('remoteAgreements', JSON.stringify(this.remoteAgreements))

      const temp = { all: false, allRequired: false }
      for (const category in this.remoteAgreements) {
        temp[category] = { checked: false, lenders: {} }
        for (const lenderName in this.remoteAgreements[category])
          temp[category].lenders[lenderName] = { checked: false }
      }
      this.remoteState = temp
      if (this.value) {
        this.policiesState = true
        this.remarketingState = {
          all: true,
          email: true,
          sms: true
        }
        this.updateCheckboxes(true)
      }
    } catch (e) {
      const self = this
      setTimeout(() => (self.agreementsUnlock = true), 5000)
    }
  },
  watch: {
    showError: function(val, oldVal) {
      // if (!oldVal && val) { // if you want to open all checkboxes after validation
      //   this.openAll = true
      // }
    },
    allCheckboxesValid(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
    policiesState: {
      handler() {
        this.$store.commit('CHANGE_ADDITIONAL_PARAMS', {
          agreements_policies: this.policiesState
        })
        this.$store.commit('UPDATE_REMOTE_AGREEMENTS_ERRORS', {
          key: 'agreements_policies',
          value: this.policiesState
        })
      },
      immediate: true,
    },
    remarketingState: {
      handler() {
        this.$store.commit('CHANGE_ADDITIONAL_PARAMS', {
          agreements_email: this.remarketingState.email,
          agreements_sms: this.remarketingState.sms
        })
        this.$store.commit('UPDATE_REMOTE_AGREEMENTS_ERRORS', {
          key: 'agreements_email',
          value: this.remarketingState.email
        })
        this.$store.commit('UPDATE_REMOTE_AGREEMENTS_ERRORS', {
          key: 'agreements_sms',
          value: this.remarketingState.sms
        })
      },
      deep: true,
      immediate: true,
    },
    remoteState: {
      handler() {
        this.$store.commit('UPDATE_REMOTE_AGREEMENTS_ERRORS', {
          key: 'agreements_partners',
          value: this.remoteState.allRequired
        })
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    splitStringByWords(inputString) {
      const linkRegex = /<a\s+(?:[^>]*?\s+)?href\s*=\s*(['"])(.*?)\1[^>]*>(.*?)<\/a>/gi
      let match
      let splitIndex = this.maxChars

      const linkPositions = []
      while ((match = linkRegex.exec(inputString)) !== null) {
        const start = match.index
        const end = linkRegex.lastIndex
        linkPositions.push({ start, end })
        splitIndex += end - start
      }

      while (splitIndex < inputString.length && inputString[splitIndex] !== ' ') {
        splitIndex++
      }

      let title = ''
      let restText = ''
      if (splitIndex < inputString.length) {
        title = inputString.slice(0, splitIndex)
        restText = inputString.slice(splitIndex + 1)
      } else {
        title = inputString
      }

      linkPositions.forEach(position => {
        if (position.start < splitIndex && position.end > splitIndex) {
          title = inputString.substring(0, position.end).trim()
          restText = inputString.substring(position.end).trim()
        }
      })
      return { title, restText }
    },
    updateCheckboxes(value, options) {
      let checkedAll = true
      let checkedAllRequired = true
      let dataForBackend = {}
      for (const category in this.remoteAgreements) {
        let categoryCheckedAll = true
        for (const lenderName in this.remoteAgreements[category]) {
          let lenderCheckedAll = true
          for (const agreement in this.remoteAgreements[category][lenderName]) {
            let agreementData = this.remoteAgreements[category][lenderName][agreement]
            if (
              !options ||
              (options && options.category === category && !options.lenderName && !options.agreementName) ||
              (options &&
                options.category === category &&
                options.lenderName === lenderName &&
                !options.agreementName) ||
              (options &&
                options.category === category &&
                options.lenderName === lenderName &&
                options.agreementName === agreement.name)
            ) {
              agreementData.checked = value
            }
            if (!agreementData.checked) {
              lenderCheckedAll = false
              if (agreementData.required) checkedAllRequired = false
            }
            if (dataForBackend[agreementData.group_key] === undefined) dataForBackend[agreementData.group_key] = {}
            dataForBackend[agreementData.group_key][agreementData.name] = agreementData.checked
          }
          this.remoteState[category].lenders[lenderName].checked = lenderCheckedAll
          if (!lenderCheckedAll) categoryCheckedAll = false
        }
        this.remoteState[category].checked = categoryCheckedAll
        if (!categoryCheckedAll) checkedAll = false
      }
      this.remoteState.all = checkedAll
      this.remoteState.allRequired = checkedAllRequired
      for (const group in dataForBackend)
        this.$store.commit('CHANGE_ADDITIONAL_PARAMS', { [group]: JSON.stringify(dataForBackend[group]) })
    },
    updateMailingCheckboxes(name, allValue) {
      if (name === 'all') {
        if (allValue !== undefined) {
          this.remarketingState = {
            all: allValue,
            email: allValue,
            sms: allValue
          }
        } else {
          this.remarketingState.email = this.remarketingState.sms = this.remarketingState.all
        }
      } else {
        if (this.remarketingState.email && this.remarketingState.sms) this.remarketingState.all = true
        else if (!this.remarketingState.email || !this.remarketingState.sms) this.remarketingState.all = false
      }
    },
    handleCheckAll(value) {
      this.policiesState = value
      this.remarketingState = {
        all: value,
        email: value,
        sms: value
      }
      this.updateCheckboxes(value)
    },
    handleCollapsibleOpenedToggle(name, value) {
      if (value) this.$store.dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'collapsibleOpen', sub5: name } })
    }
  }
}
</script>

<style lang="scss" scoped>
.remote-agreements {
  width: 100%;

  .agreement-title {
    font-size: 1em;
  }

  .agreement-text {
    padding-left: 5px;
    font-size: 1em;
    opacity: 0.8;

    &:not(:first-child) {
      margin-top: 20px;
    }
  }

  .checkbox-text {
    color: var(--white);
    font-size: 1em;

    &--bold {
      font-weight: 700;
    }

    a {
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assetComponents/RemoteAgreements.vue